<div class="row mt-1">
  <div class="col-12">

    <p class="text3-tipografia-govco">
      Su solicitud se ha registrado con éxito en el sistema con <b>número de radicado: {{ numRadicado }}.</b>
      Recuerde realizar seguimiento a su trámite a través de la Ventanilla Única de Trámites y Servicios.
    </p>
    <br>
    <p class="text3-tipografia-govco">
      Por favor verifique su mensaje de confirmación en su correo electrónico, para hacerle
      seguimiento a este trámite no olvide anotar el ID del ticket descrito a continuación,
      Muchas Gracias por utilizar los servicios en línea de la Secretaria Distrital de Salud.
    </p>
    <br><br>

    <p class="text3-tipografia-govco">
      En el siguiente link lo invitamos a diligenciar una breve encuesta:
      <a href="http://fapp.saludcapital.gov.co/encuestas/index.php?sid=16649&newtest=Y&lang=es" target="_blank"
         rel="noopener">Encuesta</a>
    </p>

  </div>
</div>
